module.exports = __webpack_public_path__ + "static/ayla-de8611758de280830fedb3c4898c5dc9.svg";